import { useState } from 'react'

const KINDS = [
  { key: 'tool', label: 'Tools & Platforms' },
  { key: 'link', label: 'Quick Access Links' },
  { key: 'subscription', label: 'Subscriptions' },
]
const blank = { name: '', kind: 'tool', useFor: '', owner: '', status: '', url: '', notes: '' }

export default function ToolsView({ tools = [], onCreate, onUpdate, onDelete }) {
  const [draft, setDraft] = useState(null) // null | {…} (new) | {id,…} (editing)

  const field = (k, ph) => (
    <input
      value={draft?.[k] || ''}
      onChange={(e) => setDraft((d) => ({ ...d, [k]: e.target.value }))}
      placeholder={ph}
      style={{ background: 'var(--color-bg-dark)', border: '1px solid var(--color-divider-dark)', borderRadius: 'var(--radius-sm)', padding: '7px 9px', color: 'var(--color-white)', fontSize: 12.5, minWidth: 0 }}
    />
  )

  const save = () => {
    if (!draft?.name?.trim()) return
    if (draft.id) onUpdate(draft.id, draft)
    else onCreate(draft)
    setDraft(null)
  }

  return (
    <>
      <div className="eyebrow" style={{ marginBottom: 12 }}><span className="tag-label" style={{ color: 'var(--color-gold)' }}>Hub</span></div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <h1 className="font-display" style={{ fontSize: 42, margin: '0 0 4px', lineHeight: 0.95, textTransform: 'uppercase', color: 'var(--color-white)' }}>Tools &amp; Links</h1>
        <div style={{ flex: 1 }} />
        <button onClick={() => setDraft({ ...blank })} className="btn btn-gold" style={{ fontSize: 12, padding: '8px 14px' }}>+ Add</button>
      </div>
      <p style={{ margin: '0 0 22px', fontSize: 13, color: 'var(--color-muted)' }}>Team tools, quick-access links, and subscriptions.</p>

      {draft && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, padding: 12, marginBottom: 18, background: 'var(--color-panel-dark)', border: '1px solid var(--color-divider-dark)', borderRadius: 'var(--radius-sm)' }}>
          {field('name', 'Name')}
          <select value={draft.kind} onChange={(e) => setDraft((d) => ({ ...d, kind: e.target.value }))} style={{ background: 'var(--color-bg-dark)', border: '1px solid var(--color-divider-dark)', borderRadius: 'var(--radius-sm)', padding: '7px 9px', color: 'var(--color-white)', fontSize: 12.5 }}>
            {KINDS.map((k) => <option key={k.key} value={k.key}>{k.label}</option>)}
          </select>
          {field('useFor', 'What we use it for')}
          {field('owner', 'Owner / Admin')}
          {field('status', 'Status')}
          {field('url', 'URL')}
          <div style={{ gridColumn: '1 / -1' }}>{field('notes', 'Notes')}</div>
          <div style={{ gridColumn: '1 / -1', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button onClick={() => setDraft(null)} className="btn" style={{ fontSize: 12, padding: '7px 12px' }}>Cancel</button>
            <button onClick={save} className="btn btn-gold" style={{ fontSize: 12, padding: '7px 12px' }}>Save</button>
          </div>
        </div>
      )}

      {KINDS.map((kind) => {
        const rows = tools.filter((t) => t.kind === kind.key)
        if (!rows.length) return null
        return (
          <section key={kind.key} style={{ marginBottom: 26 }}>
            <h2 className="tag-label" style={{ color: 'var(--color-muted)', marginBottom: 8 }}>{kind.label}</h2>
            <div style={{ border: '1px solid var(--color-divider-dark)', borderRadius: 'var(--radius-sm)', overflow: 'hidden' }}>
              {rows.map((t) => (
                <div key={t.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderTop: '1px solid var(--color-divider-dark)' }}>
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--color-white)' }}>
                      {t.url ? <a href={t.url} target="_blank" rel="noreferrer" style={{ color: 'var(--color-white)' }}>{t.name}</a> : t.name}
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--color-muted)' }}>{t.useFor}{t.owner ? ` · ${t.owner}` : ''}{t.status ? ` · ${t.status}` : ''}</div>
                  </div>
                  <button onClick={() => setDraft({ ...t })} title="Edit" style={{ background: 'none', border: 'none', color: 'var(--color-muted)', cursor: 'pointer', fontSize: 12 }}>Edit</button>
                  <button onClick={() => onDelete(t.id)} title="Delete" style={{ background: 'none', border: 'none', color: 'var(--color-muted)', cursor: 'pointer', fontSize: 13 }}>✕</button>
                </div>
              ))}
            </div>
          </section>
        )
      })}
      {tools.length === 0 && <div style={{ fontSize: 13, color: 'var(--text-dim)' }}>No tools yet. Tap + Add to create one.</div>}
    </>
  )
}
